const Footer = () => {
  return (
    <footer className="bg-muted text-muted-foreground py-6 mt-auto">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <p>Medical Association of Andhra Pradesh</p>
            <p>Email: info@maap.org</p>
            <p>Phone: +91-XXXXXXXXXX</p>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul>
              <li className="mb-2"><a href="/about" className="hover:text-gray-300">About Us</a></li>
              <li className="mb-2"><a href="/members" className="hover:text-gray-300">Members</a></li>
              <li className="mb-2"><a href="/news-events" className="hover:text-gray-300">News & Events</a></li>
              <li className="mb-2"><a href="/contact" className="hover:text-gray-300">Contact</a></li>
            </ul>
          </div>
          <div>
            <h3 className="text-lg font-semibold mb-4">Follow Us</h3>
            <div className="flex space-x-4">
              <a href="https://facebook.com/maap" className="hover:text-gray-300">Facebook</a>
              <a href="https://twitter.com/maap" className="hover:text-gray-300">Twitter</a>
              <a href="https://linkedin.com/company/maap" className="hover:text-gray-300">LinkedIn</a>
            </div>
          </div>
        </div>
        <div className="mt-8 pt-4 border-t border-gray-700 text-center">
          <p>&copy; {new Date().getFullYear()} Medical Association of Andhra Pradesh. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 